/*
const BASE_HTTP_URL = 'https://api.dev.glass-link.io';
const BASE_WS_URL = 'wss://api.dev.glass-link.io:4007';
const ADMIN_HTTP_URL = 'https://api.dev.glass-link.io:8231';
const ADMIN_WS_URL = 'wss://api.dev.glass-link.io:8231';
*/

const BASE_HTTP_URL = 'https://api.genomics.lifespangroup.com';
const BASE_WS_URL = 'wss://api.genomics.lifespangroup.com:4007';
const ADMIN_HTTP_URL = 'https://api.genomics.lifespangroup.com:8231';
const ADMIN_WS_URL = 'wss://api.genomics.lifespangroup.com:8231';

const Urls = {
    baseHttpUrl: BASE_HTTP_URL,
    baseWsUrl: BASE_WS_URL,
    adminHttpUrl: ADMIN_HTTP_URL,
    adminWsUrl: ADMIN_WS_URL,
};

export default Urls;
